var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#064E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9485 14.4516C13.8883 14.4258 13.7464 14.4086 13.5227 14.4C13.2991 14.3914 13.0582 14.387 12.8001 14.387H8.06466V13.8967C8.55498 13.5268 9.0152 13.1612 9.44531 12.8C9.87541 12.4301 10.2539 12.0645 10.5808 11.7032C10.9163 11.3419 11.1743 10.972 11.355 10.5935C11.5442 10.215 11.6389 9.82361 11.6389 9.41931C11.6389 8.9892 11.527 8.66662 11.3034 8.45157C11.0797 8.23651 10.7485 8.12898 10.3098 8.12898C9.98294 8.12898 9.72488 8.1806 9.53563 8.28382C9.34638 8.38705 9.25176 8.52038 9.25176 8.68382C9.25176 8.79565 9.28617 8.90748 9.35498 9.01931C9.4324 9.12253 9.50982 9.23436 9.58724 9.35479C9.66466 9.47522 9.70337 9.61716 9.70337 9.7806C9.70337 9.96985 9.63455 10.1204 9.49692 10.2322C9.36789 10.344 9.18724 10.4 8.95498 10.4C8.68832 10.4 8.46896 10.3139 8.29692 10.1419C8.13348 9.96985 8.05176 9.73329 8.05176 9.43221C8.05176 9.07092 8.17649 8.74834 8.42595 8.46447C8.67541 8.1806 9.0195 7.95694 9.45821 7.7935C9.89692 7.63006 10.3915 7.54834 10.9421 7.54834C11.6733 7.54834 12.2496 7.69458 12.6711 7.98705C13.0926 8.27952 13.3034 8.70103 13.3034 9.25157C13.3034 9.58705 13.2173 9.90533 13.0453 10.2064C12.8733 10.4989 12.6281 10.7914 12.3098 11.0838C12.0001 11.3763 11.6303 11.6817 11.2001 12C10.7786 12.3096 10.3098 12.6408 9.79369 12.9935V13.0709H12.4389C12.8001 13.0709 13.041 13.015 13.1614 12.9032C13.2905 12.7913 13.3722 12.5849 13.4066 12.2838H13.8969C13.8969 12.8602 13.9012 13.3075 13.9098 13.6258C13.9184 13.9354 13.9313 14.2107 13.9485 14.4516Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.0c23bccd.svg";
export { ForwardRef as ReactComponent };